import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Global } from './Global';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class EntityService {
  private _http = inject(HttpClient)
  private _url = Global.url_user
  private _headers = new HttpHeaders().set('Content-Type', 'application/json');

  getEntities() {
    return this._http.get(this._url + 'entities/get', { headers: this._headers });
  }

  getEntitiesGroup(group) {
    return this._http.get(this._url + 'entities/get-group/' + group.id, { headers: this._headers });
  }

  getAuditors() {
    return this._http.get(this._url + 'auditors', { headers: this._headers });
  }

  getGroupsEntities() {
    return this._http.get(this._url + 'entities/get-groups', { headers: this._headers });
  }

  getOffices() {
    return this._http.get(this._url + 'entities/get-offices', { headers: this._headers });
  }

  updateEntity(entity: any) {
    return this._http.patch(this._url + 'entities/update-entity', entity, { headers: this._headers });
  }

  updateGroup(group: any) {
    return this._http.patch(this._url + 'entities/update-group', group, { headers: this._headers });
  }

  updateGroups(groups: any) {
    return this._http.patch(this._url + 'entities/update-groups', groups, { headers: this._headers });
  }

  updateOffice(office: any) {
    return this._http.patch(this._url + 'entities/update-office', office, { headers: this._headers });
  }

  updateOffices(offices: any) {
    return this._http.patch(this._url + 'entities/update-offices', offices, { headers: this._headers });
  }
}
